import { inject } from '@angular/core';
import type {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RouterStateSnapshot,
} from '@angular/router';
import { NotFound } from '@freelancer/404';
import { of } from 'rxjs';
import { CargoCategoryDetailPages } from './freightlancer-cargo-category-detail-pages.model';

/**
 * This guard is used to check cargo category detail pages and if the url param
 * is not a valid category, we redirect the user to the not-found page
 */
export const FreightlancerCargoCategoryDetailPageGuard = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): ReturnType<CanActivateFn> => {
  const notFound = inject(NotFound);

  if (Object.values(CargoCategoryDetailPages).includes(route.params.category)) {
    return of(true);
  }

  return notFound.render();
};
